module.exports = __webpack_public_path__ + "img/1.86d97b89.png";